import Vue from 'vue'
import App from './App.vue'
import router from './config/router'
import store from './config/store'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLoading from 'vuejs-loading-plugin'
import Notify from "./plugins/snotify";
import "vue-snotify/styles/material.css"
import VueEllipseProgress from 'vue-ellipse-progress';
import VCalendar from "v-calendar"
// import VueApexCharts from 'vue-apexcharts'
//
// Vue.use(VueApexCharts)
Vue.use(VCalendar, {
  componentPrefix: 'vc'
})

Vue.use(VueEllipseProgress);

Vue.config.productionTip = false
Vue.config.ignoredElements = ['main-flex']

Vue.use(Notify)
Vue.use(VueLoading)
Vue.use(VueAxios, axios)
import VueTimeago from 'vue-timeago'

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
})

// Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
